import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import {
  $transferRequestsApprovedListStore,
  $transferRequestsGridListStore,
  $transferRequestsLimitsStore,
  $transferRequestsListStore,
  $transferUpdateStatusStore,
} from '@lib/store';
import { TransferRequestResponse, TransferRequestStatusEnum } from '@shared/api/rest/transferRequests';
import { TransferRequestConfirmModal } from './widgets';
import { TransferTable } from './widgets/table';
import { OTPModal } from './widgets/modal/otpModal';
import { Text } from '@shared/widgets';

export const TransferRequests = () => {
  const transferStore = useUnit($transferRequestsGridListStore.store);
  const transferRequestLimit = useUnit($transferRequestsLimitsStore.store);

  const [total, setTotal] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [count, setCount] = useState<number>(10);
  const [selectedTransfer, setSelectedTransfer] = useState<TransferRequestResponse | null>(null);
  const [otpModal, setOTPModal] = useState<TransferRequestResponse | null>(null);

  useEffect(() => {
    $transferRequestsLimitsStore.events.update();
  }, []);

  useEffect(() => {
    $transferRequestsGridListStore.events.update({
      Count: count,
      FromIndex: (currentPage - 1) * count,
    });
  }, [currentPage, $transferRequestsGridListStore, count]);

  useEffect(() => {
    setTotal(transferStore?.data?.total);
  }, [transferStore?.data?.total, currentPage, $transferRequestsGridListStore, count]);

  const closeModal = () => setSelectedTransfer(null);
  const openOTPModal = (data: TransferRequestResponse) => {
    setOTPModal(data);
    setSelectedTransfer(null);
  };

  const updateGridsData = () => {
    setCurrentPage(1);
    $transferRequestsGridListStore.events.update({
      Count: count,
      FromIndex: 0,
    });
    $transferRequestsListStore.events.update({
      status: TransferRequestStatusEnum.Submitted,
      Count: 5,
      FromIndex: 0,
    });
    $transferRequestsApprovedListStore.events.update({
      status: TransferRequestStatusEnum.WaitingForApproval,
      Count: 5,
      FromIndex: 0,
    });
  };

  const closeOTPModal = async () => {
    setOTPModal(null);
    updateGridsData();
  };

  const onSubmitHandle = async () => {
    if (selectedTransfer) {
      await $transferUpdateStatusStore.events.update({
        id: selectedTransfer.id,
        status: TransferRequestStatusEnum.WaitingForApproval,
      });
      await $transferRequestsGridListStore.events.update({
        Count: count,
        FromIndex: (currentPage - 1) * count,
      });
      await $transferRequestsListStore.events.update({
        status: TransferRequestStatusEnum.Submitted,
        Count: 5,
        FromIndex: 0,
      });
      await $transferRequestsApprovedListStore.events.update({
        status: TransferRequestStatusEnum.WaitingForApproval,
        Count: 5,
        FromIndex: 0,
      });
    }
    closeModal();
  };

  const isLimitReached = (amount: number) => amount >= transferRequestLimit.data.outgoingTransferLimit;

  return (
    <>
      <Text className='mb-6' weight='semibold' size='2xl'>
        Payment Requests
      </Text>
      <TransferTable
        data={transferStore.data.data}
        currentPage={currentPage}
        totalItemCount={total}
        countItemPage={count}
        onChangePage={setCurrentPage}
        onChangeCountItemPage={setCount}
        setSelectedTransfer={setSelectedTransfer}
        isLoading={transferStore.loading}
      />
      {selectedTransfer && (
        <TransferRequestConfirmModal
          transferData={selectedTransfer}
          onClose={closeModal}
          setOTPModal={selectedTransfer.status !== TransferRequestStatusEnum.Draft ? openOTPModal : undefined}
          cancelLabel={selectedTransfer.status === TransferRequestStatusEnum.WaitingForApproval ? 'Reject' : 'Cancel'}
          confirmLabel={selectedTransfer.status === TransferRequestStatusEnum.Draft ? 'Send' : 'Approve'}
          transactionId={selectedTransfer.id}
          extraSubmitHandle={selectedTransfer.status === TransferRequestStatusEnum.Draft ? onSubmitHandle : undefined}
          readOnly={
            selectedTransfer.status !== TransferRequestStatusEnum.Draft && selectedTransfer.status !== TransferRequestStatusEnum.WaitingForApproval
          }
          isLimitReached={isLimitReached(selectedTransfer.senderAmount)}
          updateGridsData={updateGridsData}
          isOpen={selectedTransfer ? true : false}
        />
      )}
      {otpModal && <OTPModal onClose={closeOTPModal} data={otpModal} />}
    </>
  );
};
